module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.isOpen) ? _c('div', [_c('div', {
    staticClass: "startup-box-wrap"
  }, [_c('div', {
    staticClass: "startup-box"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "height": "100%"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "50px",
      "height": "100%"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex": "1",
      "height": "100%"
    }
  }, [_c('AppList')], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex": "2",
      "height": "100%"
    }
  }, [_c('TileList')], 1)])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d31fa84c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/StartupList.vue
// module id = 154
// module chunks = 1